import { inject, injectable } from 'inversify'

import { SessionStore } from '@infrastructure/stores/session/session-store'

import { TrackingManager } from './tracking-manager'

@injectable()
export class SignInTrackingManager {
  constructor(
    @inject(TrackingManager)
    private readonly trackingManager: TrackingManager,
    @inject(SessionStore)
    private readonly sessionStore: SessionStore,
  ) {}

  public async track(sessionMethod: 'sign-in' | 'refresh'): Promise<void> {
    const { lastLogin } = this.sessionStore.getState()

    // Sign In event should only be sent once per session or if the user has been active for a period of time
    const shouldSend = !lastLogin || (Date.now() - lastLogin) / 3_600_000 > 3

    if (shouldSend) {
      await this.trackingManager.track('sign', 'sign-in', {
        sessionMethod,
      })

      this.sessionStore.getState().setLastLogin()
    }
  }
}
